module.exports = __webpack_public_path__ + "login-form-6b98a2b5/background-bf0cd5740250d8de53a3c4542317da8f.png";